import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

import { Modal, ModalBody, ModalFooter, Button, Input, Form } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { endpoints } from 'Core/defaultValues';

//Actions 
import {
    brandsGetBrandRequest,
    brandsEditBrandRequest,
    brandsEditNewBrandRequest,
    clearRedux,
} from 'Redux/actions';


//Styles
import './index.scss';

const EditBrand = (props) => {
    const { tableRef, getBrand } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);

    const currentBrand = useSelector(state => state.editBrandRedux.brand);
    const newBrand = useSelector(state => state.editBrandRedux.newBrand);

    const [title, setTitle] = useState("");
    const [code, setCode] = useState("");
    const [domains, setDomains] = useState([]);
    const [homePageUrl, setHomePageUrl] = useState("");
    const [tosUrl, setTosUrl] = useState("");
    const [helpUrl, setHelpUrl] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [loginBackgroundImage, setLoginBackgroundImage] = useState("");
    const [loginBackgroundColor, setLoginBackgroundColor] = useState("");
    const [loginCompanyLogo, setLoginCompanyLogo] = useState("");
    const [favicon, setFavicon] = useState("");
    const [inAppLogo, setInAppLogo] = useState("");

    const [brand, setBrand] = useState({});

    const {
        editBrand,
        loading,
        openModal
    } = useSelector(state => state.editBrandRedux);



    const closeModal = () => {
        dispatch(clearRedux("EDIT_BRAND"));
        setTitle("");
        setCode("");
        setDomains([]);
        setHomePageUrl("");
        setTosUrl("");
        setHelpUrl("");
        setAddress("");
        setPhone("");
        setLoginBackgroundImage("");
        setLoginBackgroundColor("");
        setLoginCompanyLogo("");
        setFavicon("");
        setInAppLogo("");
        setBrand(null);

    }

    const editBrandRequest = () => {

        let payload = {
            code: code?.trim(),
            title: title?.trim(),
            domains: domains?.length > 0 ? JSON.stringify(domains) : "[]",
            homePageUrl: homePageUrl?.trim(),
            tosUrl: tosUrl?.trim() || "",
            helpUrl: helpUrl?.trim() || "",
            address: address?.trim() || "",
            phone: phone?.trim() || "",
            loginBackgroundImage: loginBackgroundImage?.trim() || "",
            loginBackgroundColor: loginBackgroundColor?.trim() || "",
            loginCompanyLogo: loginCompanyLogo?.trim() || "",
            favicon: favicon?.trim() || "",
            inAppLogo: inAppLogo?.trim() || "",
        }

        if (currentBrand) {
            payload.id = currentBrand?.id;
            dispatch(brandsEditBrandRequest(payload))
        } else {
            dispatch(brandsEditNewBrandRequest(payload))
        }
    }


    useEffect(() => {
        //Get brand data
        if (getBrand) {
            dispatch(brandsGetBrandRequest(getBrand));
        }

        return () => {
            dispatch(clearRedux("EDIT_BRAND"));
        }
    }, []);


    useEffect(() => {

        //Brand editing confirmation message
        if (editBrand?.id) {
            NotificationManager.success(
                messages['edit_brand_the_brand_has_been_edited'],
                messages['edit_brand_edit_title'],
                3000,
            );
            tableRef && tableRef?.current?.getData();
            closeModal();
        } else if (editBrand?.error) {
            NotificationManager.error(
                messages['edit_brand_error_editing_brand'],
                messages['edit_brand_edit_title'],
                3000,
            );
        }

        //New brand creation confirmation message
        if (newBrand) {
            dispatch(clearRedux("EDIT_BRAND", { newBrand: null }));
            if (newBrand?.error) {
                NotificationManager.error(
                    messages['edit_brand_error_creating_brand'],
                    messages['edit_brand_create_title'],
                    3000,
                );
            } else {
                NotificationManager.success(
                    messages['edit_brand_the_brand_has_been_created'],
                    messages['edit_brand_create_title'],
                    3000,
                );
                tableRef && tableRef?.current?.getData();
                closeModal();
            }
        }

    }, [editBrand, newBrand]);

    //Set brand data to form
    useEffect(() => {
        if (currentBrand) {
            setTitle(currentBrand?.title);
            setCode(currentBrand?.code);
            setDomains(currentBrand?.domains);
            setHomePageUrl(currentBrand?.homePageUrl);
            setTosUrl(currentBrand?.tosUrl);
            setHelpUrl(currentBrand?.helpUrl);
            setAddress(currentBrand?.address);
            setPhone(currentBrand?.phone);
            setLoginBackgroundImage(currentBrand?.loginBackgroundImage);
            setLoginBackgroundColor(currentBrand?.loginBackgroundColor);
            setLoginCompanyLogo(currentBrand?.loginCompanyLogo);
            setFavicon(currentBrand?.favicon);
            setInAppLogo(currentBrand?.inAppLogo);
        }
    }, [currentBrand]);

    return (
        <Modal
            open={openModal}
            title={currentBrand ? `${messages['edit_brand_edit_title']} - ${currentBrand?.title}` : messages['edit_brand_create_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
            className="create-brand-modal"
        >
            <ModalBody className="body-create-brand">

                <div className="create-brand-tab-container">
                    <Form
                        ref={formRef}
                        onSubmit={() => {
                            return true
                        }}
                        onValidSubmit={() => {
                            editBrandRequest();
                        }}
                    >
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_brand_code']}
                                placeholder={messages['edit_brand_brand_code']}
                                value={code}
                                onChange={(value) => setCode(value)}
                                required
                                requiredMessage={messages['required_field']}
                                maxLength={40}
                                minLength={3}
                                minLengthMessage={`${messages['edit_brand_brand_code_min_error']} 3`}
                                maxLengthMessage={`${messages['edit_brand_brand_code_max_error']} 40`}
                            />
                        </div>
                        {
                            currentBrand &&
                            <div style={{ textAlign: 'left', margin: 10 }}>
                                <a
                                    style={{ marginRight: 10, color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                                    onClick={(e) => {
                                        window.open(`${endpoints.CLOUD_WEBSITE}/reseller/${code}`, '_blank');
                                    }}
                                >
                                    {`${endpoints.CLOUD_WEBSITE}/reseller/${code}`}
                                </a>
                            </div>
                        }
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_brand_name']}
                                placeholder={messages['edit_brand_brand_name']}
                                value={title}
                                onChange={(value) => setTitle(value)}
                                required
                                requiredMessage={messages['required_field']}
                                maxLength={40}
                                minLength={3}
                                minLengthMessage={`${messages['edit_brand_brand_name_min_error']} 3`}
                                maxLengthMessage={`${messages['edit_brand_brand_name_max_error']} 40`}
                            />
                        </div>
                        <div style={{ textAlign: 'left', margin: 10 }}>
                            <label style={{ fontWeight: 'bold' }}>{messages['edit_brand_domains']}</label>
                        </div>
                        <div style={{ margin: 10 }}>
                            <textarea
                                style={{ minHeight: 50 }}
                                value={domains?.join(',') || ""}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    setDomains(value?.split(',')?.map((item) => item.trim()) || []);
                                }}
                                placeholder={messages['edit_brand_domains']}
                                className="form-control"
                                maxLength={1000}
                            />
                        </div>
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_home_page_url']}
                                placeholder={messages['edit_brand_home_page_url']}
                                value={homePageUrl}
                                onChange={(value) => setHomePageUrl(value)}
                                maxLength={1000}
                            />
                        </div>
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_tos_url']}
                                placeholder={messages['edit_brand_tos_url']}
                                value={tosUrl}
                                onChange={(value) => setTosUrl(value)}
                                maxLength={1000}
                            />
                        </div>
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_help_url']}
                                placeholder={messages['edit_brand_help_url']}
                                value={helpUrl}
                                onChange={(value) => setHelpUrl(value)}
                                maxLength={1000}
                            />
                        </div>
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_address']}
                                placeholder={messages['edit_brand_address']}
                                value={address}
                                onChange={(value) => setAddress(value)}
                                maxLength={1000}
                            />
                        </div>
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_phone']}
                                placeholder={messages['edit_brand_phone']}
                                value={phone}
                                onChange={(value) => setPhone(value)}
                                maxLength={1000}
                            />
                        </div>
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_login_background_image']}
                                placeholder={messages['edit_brand_login_background_image']}
                                value={loginBackgroundImage}
                                onChange={(value) => setLoginBackgroundImage(value)}
                                maxLength={1000}
                            />
                        </div>
                        <div style={{ textAlign: 'left', margin: 10 }}>
                            <label style={{ fontWeight: 'bold' }}>{messages['edit_brand_login_background_color']}</label>
                        </div>
                        <div style={{ textAlign: '', display: 'flex', padding: '5px 0px', marginTop: 5 }}>
                            <div style={{ textAlign: 'left', padding: '0px 10px' }}>
                                <input type="color" id="head" name="head" value={`${loginBackgroundColor}`} onChange={e => setLoginBackgroundColor(e.target.value)} />
                            </div>
                        </div>
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_login_company_logo']}
                                placeholder={messages['edit_brand_login_company_logo']}
                                value={loginCompanyLogo}
                                onChange={(value) => setLoginCompanyLogo(value)}
                                maxLength={1000}
                            />
                        </div>
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_favicon']}
                                placeholder={messages['edit_brand_favicon']}
                                value={favicon}
                                onChange={(value) => setFavicon(value)}
                                maxLength={1000}
                            />
                        </div>
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['edit_brand_in_app_logo']}
                                placeholder={messages['edit_brand_in_app_logo']}
                                value={inAppLogo}
                                onChange={(value) => setInAppLogo(value)}
                                maxLength={1000}
                            />
                        </div>
                    </Form>
                </div>

            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => {
                        closeModal();
                    }}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => {

                        formRef?.current?.submit();

                    }}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal >
    );
}
export default EditBrand